import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';
import AL from '@assets/images/flags/AL.svg';
import GB from '@assets/images/flags/GB.svg';
import IT from '@assets/images/flags/IT.svg';
const LanguageSelector = () => {
  const [showDropdown, setShowDropdown] = useState(false);

  const { i18n } = useTranslation();

  const toggleDropdown = () => setShowDropdown((prevState) => !prevState);

  const switchLanguage = useCallback(
    (lang) => {
      toggleDropdown();
      void i18n.changeLanguage(lang).then(() => localStorage.setItem('lang', lang));
      window.location.reload();
    },
    [i18n]
  );

  const languageOptions = useMemo(
    () =>
      ['al', 'en', 'it'].map((lang) => (
        <div
          id={lang}
          key={lang}
          className={`flex justify-center py-2 px-1 ${
            i18n.language === lang
              ? `bg-gradient-to-r from-cyan-600 from-10% via-sky-900 via-30% to-blue-900 to-90% text-white`
              : 'hover:bg-blue-100 hover:bg-opacity-20 cursor-pointer'
          }`}
          onClick={() => switchLanguage(lang)}>
          <img className="w-7" src={lang === 'al' ? AL : lang === 'it' ? IT : GB} alt="alb-flag" />
        </div>
      )),
    [switchLanguage, i18n.language]
  );

  return (
    <div className="relative w-11 font-sans">
      <div
        className="bg-gradient-to-r from-cyan-600 from-10% via-sky-900 via-30% to-blue-900 to-90%  ml-2 rounded-lg w-full focus:outline-none p-1 flex items-center cursor-pointer text-primary-500 transition-text duration-300"
        onClick={toggleDropdown}>
        <div className="uppercase text-sm text-white font-semibold">
          <img className="w-7" src={i18n.language === 'al' ? AL : i18n.language === 'it' ? IT : GB} alt="alb-flag" />
        </div>
        <FaChevronDown
          className={`h-2.5 ml-0.5 ${
            showDropdown ? '-rotate-180' : 'rotate-0'
          } transition duration-200 text-white`}
        />
      </div>
      <div
        className={`ml-2 ${
          showDropdown ? 'max-h-56 border' : 'max-h-0'
        } transition-all duration-200 ease-in w-full absolute z-50 bg-white mt-0.5 rounded-md shadow-2xl overflow-hidden`}>
        {languageOptions}
      </div>
    </div>
  );
};

export default LanguageSelector;
